<template>
  <div>
    <Table border :columns="columns1" :data="data1"></Table>
    <br />
    <Page :total="total" show-total @on-change="changePage" @on-page-size-change="changePagesize" />
  </div>
</template>
<script>
export default {
  props: {
    inventoryId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      columns1: [
        {
          title: "入库单号",
          key: "stockNo",
          minWidth: 130,
          align: "center",
        },
        {
          title: "耗材名称",
          key: "name",
          minWidth: 100,
          align: "left",
        },
        {
          title: "入库数量",
          minWidth: 80,
          key: "quantity",
          align: "center",
        },
        {
          title: "入库人",
          key: "stockUserName",
          minWidth: 100,
          align: "center",
        },
        {
          title: "入库时间",
          minWidth: 180,
          key: "stockDate",
          align: "center",
        },
      ],
      data1: [],
      total: this.total,
    };
  },
  created() {
  },
  mounted() {
    if (this.inventoryId) {
      this.load(this.inventoryId);
    }
  },
  methods: {
    load(inventoryId, page = 1) {
      let q = {};
      q.inventoryId = inventoryId;
      q.pageSize = 10;
      q.pageNum = page;
      q.orderByColumn = "createTime";
      q.isAsc = "descending";
      $utils.api
        .load("/admin/system/sysConsumableStock/list", q)
        .then((res) => {
          if (res.code > 0) {
            let data = res.rows;
            let list = data || [];
            this.data1 = list;
            this.total = res.total;
          }
        })
        .catch(() => {
          $utils.toast.error("请求错误");
        });
    },
    changePage(p) {
      this.load(this.inventoryId, p);
    },
    changePagesize(psize) { },
  },
};
</script>
